import React from 'react'
import LegalLayout, { Section, Para, Bullets, Accent } from '../components/LegalLayout'

const PrivacyPolicy = () => {
  return (
    <LegalLayout title='Privacy Policy' lastUpdated='25 June 2026'>
        <Para>
          This Privacy Policy describes how <Accent>Nilay Singh</Accent> (“we”, “us”, or “our”)
          collects, uses, and protects the information you provide when you visit this website or
          engage our services and make a payment. By using this website you agree to the practices
          described in this policy.
        </Para>

        <Section heading='1. Information We Collect'>
          <Para>We may collect the following information from you:</Para>
          <Bullets items={[
            'Contact details such as your name, email address, and phone number.',
            'Billing information required to process a payment (handled securely by our payment gateway).',
            'Project or service details that you voluntarily share with us.',
            'Technical data such as your IP address, browser type, and usage data collected automatically.'
          ]} />
        </Section>

        <Section heading='2. How We Use Your Information'>
          <Para>The information we collect is used to:</Para>
          <Bullets items={[
            'Provide, operate, and deliver the services or products you request.',
            'Process payments and send transaction confirmations or invoices.',
            'Respond to your enquiries and provide customer support.',
            'Improve our website, services, and user experience.',
            'Comply with legal and regulatory obligations.'
          ]} />
        </Section>

        <Section heading='3. Payment Information'>
          <Para>
            All online payments are processed through <Accent>Razorpay</Accent>, a PCI-DSS compliant
            payment gateway. We do not store your card numbers, UPI PINs, net-banking passwords, or
            other sensitive payment credentials on our servers. Such information is collected and
            processed directly by the payment gateway under its own privacy and security policies.
          </Para>
        </Section>

        <Section heading='4. Sharing of Information'>
          <Para>
            We do not sell or rent your personal information. We may share your information only with
            trusted third parties who help us operate our website and process payments (such as our
            payment gateway), or when required by law, regulation, or legal process.
          </Para>
        </Section>

        <Section heading='5. Data Security'>
          <Para>
            We implement reasonable technical and organisational measures to protect your information
            against unauthorised access, alteration, disclosure, or destruction. However, no method of
            transmission over the Internet is completely secure, and we cannot guarantee absolute
            security.
          </Para>
        </Section>

        <Section heading='6. Cookies'>
          <Para>
            Our website may use cookies and similar technologies to improve functionality and analyse
            usage. You can choose to disable cookies through your browser settings, though some parts
            of the website may not function properly as a result.
          </Para>
        </Section>

        <Section heading='7. Your Rights'>
          <Para>
            You may request access to, correction of, or deletion of your personal information held by
            us by contacting us using the details below. We will respond to such requests within a
            reasonable timeframe.
          </Para>
        </Section>

        <Section heading='8. Changes to This Policy'>
          <Para>
            We may update this Privacy Policy from time to time. Any changes will be posted on this
            page with a revised “Last updated” date.
          </Para>
        </Section>

        <Section heading='9. Contact Us'>
          <Para>If you have any questions about this Privacy Policy, you can reach us at:</Para>
          <Bullets items={[
            <><Accent>Name:</Accent> Nilay Singh</>,
            <><Accent>Email:</Accent> snilay011@gmail.com</>,
            <><Accent>Phone:</Accent> +91 9810237655</>,
            <><Accent>Address:</Accent> Shipra Riviera, Indirapuram, Ghaziabad, Uttar Pradesh, India</>
          ]} />
        </Section>
    </LegalLayout>
  )
}

export default PrivacyPolicy
